import { isPromise } from '../utils';
export function convertResultToResponse(m, domain, serviceName) {
  return function (data) {
    var result = {
      serviceName: serviceName,
      name: m.name,
      domain: domain,
      payload: data
    }; // validatePayload(result, m.response.schema);

    return result;
  };
}
export function callMethod(method, payload) {
  try {
    var result = method(payload);
    return isPromise(result) ? result : Promise.resolve(result);
  } catch (e) {
    return Promise.reject(e);
  }
}
//# sourceMappingURL=utils.js.map